import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconAdd.tsx
const OutlinedFilledAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z" })
});
const OutlinedAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z" })
});
const RoundedFilledAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H222q-19.75 0-33.37-13.68Q175-460.35 175-480.18q0-19.82 13.63-33.32Q202.25-527 222-527h211v-211q0-19.63 13.68-33.81Q460.35-786 480.18-786q19.82 0 33.32 14.19Q527-757.63 527-738v211h211q19.63 0 33.81 13.68Q786-499.65 786-479.82q0 19.82-14.19 33.32Q757.63-433 738-433H527v211q0 19.75-13.68 33.37Q499.65-175 479.82-175q-19.82 0-33.32-13.63Q433-202.25 433-222v-211Z" })
});
const RoundedAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H222q-19.75 0-33.37-13.68Q175-460.35 175-480.18q0-19.82 13.63-33.32Q202.25-527 222-527h211v-211q0-19.63 13.68-33.81Q460.35-786 480.18-786q19.82 0 33.32 14.19Q527-757.63 527-738v211h211q19.63 0 33.81 13.68Q786-499.65 786-479.82q0 19.82-14.19 33.32Q757.63-433 738-433H527v211q0 19.75-13.68 33.37Q499.65-175 479.82-175q-19.82 0-33.32-13.63Q433-202.25 433-222v-211Z" })
});
const SharpFilledAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z" })
});
const SharpAdd = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M433-433H175v-94h258v-259h94v259h259v94H527v258h-94v-258Z" })
});
const componentMap = {
	outlined: OutlinedAdd,
	"outlined-fill": OutlinedFilledAdd,
	rounded: RoundedAdd,
	"rounded-fill": RoundedFilledAdd,
	sharp: SharpAdd,
	"sharp-fill": SharpFilledAdd
};
const IconAdd = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconAdd };